/**
 * Collective Backorder Lead-Time UX
 *
 * When a customer clicks the "contact us for ETA" link in the lead-time
 * notice, scroll to the Ask-a-Question collapsible block, open it, and
 * pre-populate the message textarea with the product and variant title.
 *
 * The notice itself is server-rendered by snippets/product-inventory.liquid,
 * and only for a backordered Collective variant. Since Impulse 10.0 that
 * snippet sits in a data-kit-refresh="inventory" region, so the theme
 * re-renders it for each variant the shopper picks; no variant-change JS is
 * needed (the old variant-change half of this file was removed 2026-10-16).
 * The click handler is delegated on document, so it also works on markup the
 * refresh swaps in.
 *
 * See CUSTOMIZATIONS.md "Collective backorder lead-time notice."
 */
(function () {
  'use strict';

  function findContactCollapsibleTrigger() {
    // Tab-contact is rendered inside a `<div class="collapsibles-wrapper">` and
    // its trigger has `aria-controls="Product-content-XYZ"`. The button is
    // distinguishable from other collapsible triggers on the PDP by having a
    // contact form inside its collapsible-content sibling.
    var triggers = document.querySelectorAll('.collapsible-trigger[aria-controls^="Product-content-"]');
    for (var i = 0; i < triggers.length; i++) {
      var controlsId = triggers[i].getAttribute('aria-controls');
      var panel = document.getElementById(controlsId);
      if (panel && panel.querySelector('textarea[name="contact[body]"]')) {
        return { trigger: triggers[i], panel: panel };
      }
    }
    return null;
  }

  function openCollapsible(trigger, panel) {
    // Archetype's collapsibles use aria-expanded + a `is-open` class on both
    // the trigger and the panel. The vendor JS reads attribute changes via
    // listener; programmatically clicking the trigger gives us the cleanest
    // animation behavior.
    if (trigger.getAttribute('aria-expanded') !== 'true') {
      trigger.click();
    }
    // Belt-and-suspenders: ensure the panel is visible if click() didn't fire
    // for some theme-version reason.
    setTimeout(function () {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }, 50);
  }

  function fillMessage(panel, variantTitle, productTitle) {
    var textarea = panel.querySelector('textarea[name="contact[body]"]');
    if (!textarea) return;
    var msg = 'Lead time for ' + productTitle;
    if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
      msg += ' — ' + variantTitle;
    }
    msg += '?';
    // Only overwrite if empty or if the existing body is also one of our
    // generated lead-time prefills (so we don't clobber a real message in
    // progress). Detect generated messages by the "Lead time for " prefix.
    if (!textarea.value || /^Lead time for /.test(textarea.value)) {
      textarea.value = msg;
      // Move caret to end so it feels editable
      try { textarea.setSelectionRange(msg.length, msg.length); } catch (_) {}
    }
  }

  function handleLeadtimeClick(e) {
    var link = e.target.closest && e.target.closest('.poolaroo-cv-leadtime-link');
    if (!link) return;
    e.preventDefault();

    var ctx = findContactCollapsibleTrigger();
    if (!ctx) {
      // No Ask-a-Question block on this page — fall back to contact page.
      window.location.href = '/pages/contact';
      return;
    }

    var variantTitle = link.getAttribute('data-variant-title') || '';
    var productTitle = link.getAttribute('data-product-title') || '';

    openCollapsible(ctx.trigger, ctx.panel);
    fillMessage(ctx.panel, variantTitle, productTitle);

    // Scroll the panel into view and focus the textarea so the user can
    // type more without scrolling further or clicking. Slight delay so the
    // accordion has time to expand.
    setTimeout(function () {
      var textarea = ctx.panel.querySelector('textarea[name="contact[body]"]');
      var target = textarea || ctx.panel;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (textarea) textarea.focus({ preventScroll: true });
    }, 250);
  }

  document.addEventListener('click', handleLeadtimeClick, false);
})();
